var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',_vm._b({staticClass:"primary-link"},'base-link',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(" message")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }